import { FormControl, UntypedFormGroup } from '@angular/forms';
import { CLPApplianceDetailsPersonDetailsForm } from '../../models/clp/clp-appliance-details-person-details-form.interface';
import { CLPApplianceDetailsPersonDetailsFormField } from '../../models/clp/clp-appliance-details-person-form-field.enum';

export const mockCLPApplianceDetailsPersonDetailForm: CLPApplianceDetailsPersonDetailsForm =
  {
    [CLPApplianceDetailsPersonDetailsFormField.Address]: new UntypedFormGroup({
      id: new FormControl(),
      addressLine1: new FormControl(),
      addressLine2: new FormControl(),
      addressLine3: new FormControl(),
      addressLine4: new FormControl(),
      postalCode: new FormControl(),
      countryCode: new FormControl(),
      countryIso2: new FormControl(),
      countryIso3: new FormControl(),
      countryIsoNumber: new FormControl(),
      countryName: new FormControl(),
      type: new FormControl(),
      isOverrideAddress: new FormControl(),
    }),
    [CLPApplianceDetailsPersonDetailsFormField.FirstName]: new FormControl(),
    [CLPApplianceDetailsPersonDetailsFormField.Surname]: new FormControl(),
    [CLPApplianceDetailsPersonDetailsFormField.Title]: new FormControl(),
  };
